var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switcher',{attrs:{"active":_vm.activeLocale,"inactive":_vm.inactiveLocale},on:{"toggle":_vm.toggleLocale}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1006fd2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/SwitcherContainer.vue
// module id = null
// module chunks = 